import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getDashboardV2TaskQueueRequest = (query, params) =>
  restRequest({
    uri: '../v2/dashboard/taskQueue',
    query,
    method: HttpMethods.Get,
    ...params,
  });
